import { Perfil } from '@/types/administracao/cadastro-permissoes/perfil';
import { Service } from '../mainService';
import { PortalError } from "@/types/portal-error";


const perfisService = {
    buscarPerfil,
    adicionarPerfil,
    editarPerfil,
    buscarPerfis,
    removerPerfil,
    listarPerfis,
    buscarPerfisRaw
}


//api Nova
async function listarPerfis(CIN?: string) {
    let url = `${process.env.VUE_APP_API_USUARIOS}perfil/perfisCadastro`
    if (CIN) url = url + `?cin=${CIN}`
    const response = await Service.$http.get(url)
    if (response && response.status === 200) return response.data.map((p: any) => new Perfil(p))
    else throw new PortalError("Falha ao tentar listar perfis.");
}


async function buscarPerfis() {

    try {
        const response = await Service.$http.get(process.env.VUE_APP_USERS_API + "/perfis/listar");
        if (response && response.status === 200) {
            const retorno = response.data
            //console.log(retorno)
            return retorno;
        } else {
            throw new Error(response.data && response.data.msg ? response.data.msg : 'Ocorreu um erro ao carregar perfis.')
        }

    } catch (e: any) {
        return e.response;
    }
}

async function buscarPerfisRaw() {


    return await Service.$http.get(process.env.VUE_APP_USERS_API + "/perfis/listar");


}

async function buscarPerfil(id: number) {
    try {
        const response = Service.$http.get(process.env.VUE_APP_USERS_API + "/perfis/buscar/" + id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function adicionarPerfil(data: Perfil) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/perfis/adicionar", data);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function editarPerfil(data: Perfil) {
    try {
        const response = Service.$http.post(process.env.VUE_APP_USERS_API + "/perfis/editar/" + data.Id, data);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

async function removerPerfil(id: number) {
    try {
        const response = Service.$http.delete(process.env.VUE_APP_USERS_API + "/perfis/remover/" + id);
        return response;
    } catch (e: any) {
        return e.response;
    }
}

export default perfisService;